import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.followUpSms.1";
import { IExtraData } from "./schema.followUpSms.types";
import { getInitialValues } from "./schema.followUpSms.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues),
      uiSchema: uiSchema1(),
    },
  ];
};
